import { Customer, Order, Shop } from "cs.node.utils/csapi/provisioning"
import { SearchResult, SearchResultItemSkuParent, SearchResultTypeEnum } from "cs.node.utils/SearchUtils"
import HeaderSearchBarResultCustomer from "./HeaderSearchBarResultComponents.tsx/HeaderSearchBarResultCustomer"
import HeaderSearchBarResultItem from "./HeaderSearchBarResultComponents.tsx/HeaderSearchBarResultItem"
import HeaderSearchBarResultOrder from "./HeaderSearchBarResultComponents.tsx/HeaderSearchBarResultOrder"
import HeaderSearchBarResultShop from "./HeaderSearchBarResultComponents.tsx/HeaderSearchBarResultShop"

const HeaderSearchBarResult = ({result}: {result: SearchResult}) => {
    switch(result.type) {
        case SearchResultTypeEnum.Item:
            return <HeaderSearchBarResultItem content={(result.content as SearchResultItemSkuParent)} />
        case SearchResultTypeEnum.Order:
            return <HeaderSearchBarResultOrder order={(result.content as Order)} />
        case SearchResultTypeEnum.Shop:
            return <HeaderSearchBarResultShop shop={(result.content as Shop)} />
        case SearchResultTypeEnum.Customer:
            return <HeaderSearchBarResultCustomer customer={(result.content as Customer)} />
        default:
            return null
    }
}

export default HeaderSearchBarResult